import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { CookiesProvider } from 'react-cookie'
import { ThemeProvider } from 'styled-components/macro'
import { BrowserRouter } from 'react-router-dom'
import { TourProvider } from 'src/components/Tour/TourContext'
import { ConsentBanner } from 'src/components/ConsentBanner/ConsentBanner'
import theme from '../designSystem/theme'
import { GlobalStyle } from '../globalStyles'
import { EnvConfig } from '../config/config'
import { GatekeeperProvider } from './Gatekeeper'
import { FeatureFlagProvider } from './FeatureFlagProvider'
import { AuthProvider } from './authContext'
import { AnalyticsProvider } from './AnalyticsProvider'
import { ConsentProvider } from './ConsentContext'
import { SWRProvider } from './SWRProvider'

// Workaround for React 18 compatibility issues https://github.com/styled-components/styled-components/issues/3738
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const GlobalStyleProxy: any = GlobalStyle

export const AppProviders = ({
  children,
}: {
  children: JSX.Element
}): JSX.Element => {
  const childProviders = (
    <HelmetProvider>
      <CookiesProvider>{children}</CookiesProvider>
    </HelmetProvider>
  )

  return (
    <React.StrictMode>
      {/* @ts-ignore */}
      <ThemeProvider theme={theme}>
        <GlobalStyleProxy color="text.default" bg="white" />
        <GatekeeperProvider>
          <AuthProvider>
            <ConsentProvider>
              <>
                <ConsentBanner />
                <BrowserRouter>
                  <SWRProvider>
                    <FeatureFlagProvider>
                      <TourProvider>
                        {EnvConfig.gaMeasurementId && EnvConfig.name ? (
                          <AnalyticsProvider>
                            {childProviders}
                          </AnalyticsProvider>
                        ) : (
                          childProviders
                        )}
                      </TourProvider>
                    </FeatureFlagProvider>
                  </SWRProvider>
                </BrowserRouter>
              </>
            </ConsentProvider>
          </AuthProvider>
        </GatekeeperProvider>
      </ThemeProvider>
    </React.StrictMode>
  )
}
